import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    CarOutlined,
    UserOutlined,
    CreditCardOutlined,
    SolutionOutlined,
    InfoCircleOutlined,
    DownloadOutlined,
} from '@ant-design/icons';
import { Layout, Table, Tag, Modal, message, Button } from 'antd';
import useApplicationSession from '../../session/UserSession';
import moment from 'moment';
import { updateSubscription, downloadInvoice, getPaymentMethod, downloadContract, cancelSubscription } from '../../api';
import InvoiceDialog from '../../components/dialog/InvoiceDialog';

const { Content } = Layout;

var global_token;

const CurrentSubscription = ({ data }) => {
    const history = useHistory();
    const [billings, setBilling] = useState([]);
    const [cards, setCard] = useState([]);
    const [invoiceDialog, setVisibleInvoiceDialog] = useState({
        visible: false,
        data: {},
    });
    const [downloadContractLoading, setLoadingForDownloadContract] = useState(false);
    const token = useApplicationSession();
    global_token = token;
    const handleVisibleInvoiceDialog = ({ visible, bill }) => {
        setVisibleInvoiceDialog({ visible, data: bill });
    };
    const loadSubscription = useCallback(() => {
        const temp_billings = data?.billings.map((bill) => {
            Object.assign(bill, { viewInvoice: handleVisibleInvoiceDialog });
            return bill;
        });
        setBilling(temp_billings);
    }, [data]);

    const loadPayment = useCallback(() => {
        getPaymentMethod({ token })
            .then((response) => {
                setCard(response.cards);
            })
            .catch((error) => {
                console.error(error.response);
            });
    }, [token]);

    useEffect(() => {
        loadSubscription();
        loadPayment();
    }, [loadSubscription, loadPayment]);

    const handleUpdateSubscriptionUseCallBack = useCallback(
        (status) => {
            Modal.confirm({
                title: 'Warning',
                icon: <InfoCircleOutlined />,
                content: 'Are you sure want to do this action? You will cancel (or) delete your subscription.',
                onOk: () => {
                    updateSubscription({
                        token,
                        id: data?.id,
                        request: { status: status },
                    })
                        .then((response) => {
                            history.push('/subscriptions?status=history');
                        })
                        .catch((error) => {
                            if (error.response) {
                                message.error(error?.response?.data?.message);
                            }
                        });
                },
                okText: 'Yes',
                cancelText: 'No',
            });
        },
        [data, history, token]
    );

    const handleCancelSubscription = (id) => {
        Modal.confirm({
            title: 'Warning',
            icon: <InfoCircleOutlined />,
            content: 'Are you sure want to do this action? You will cancel your subscription.',
            onOk: () => {
                const request = { token: token, id: id };
                cancelSubscription(request)
                    .then((response) => {
                        message.success(response?.data?.message);
                        window.location.reload(true);
                    })
                    .catch((error) => {
                        if (error.response) {
                            message.error(error?.response?.data?.message);
                        }
                    });
            },
            okText: 'Yes',
            cancelText: 'No',
        });
    };
    const handleDownload = (id) => {
        setLoadingForDownloadContract(true);
        downloadContract({ token: global_token, Id: id })
            .then(() => {
                setLoadingForDownloadContract(false);
            })
            .catch(() => {
                setLoadingForDownloadContract(false);
            });
    };

    const getSubscriptionStatusColor = (type) => {
        switch (type) {
            case 'pending':
                return 'horizontal-container-element currentStatus currentStatusPending';
            case 'open':
                return 'horizontal-container-element currentStatus currentStatusSuccess';
            case 'approved':
                return 'horizontal-container-element currentStatus currentStatusSuccess';
            case 'active':
                return 'horizontal-container-element currentStatus currentStatusSuccess';

            default:
                return 'horizontal-container-element currentStatus';
        }
    };

    const renderVehiclePlate = (status) => {
        switch (status) {
            case 'pending':
                return <></>;

            case 'approved':
                return <></>;

            default:
                return (
                    <>
                        <label className="horizontal-container-element">Plate No : </label>
                        <h6 className="horizontal-container-element label-information">
                            {data?.vehicle?.license_plate_number}
                        </h6>
                    </>
                );
        }
    };

    const renderEndSubscriptionButton = (status) => {
        switch (status) {
            case 'close':
                return <></>;

            case 'rejected':
                return <></>;

            default:
                return (
                    <input
                        type="button"
                        onClick={() => handleUpdateSubscriptionUseCallBack('closed')}
                        className="btnSubscripton danger-btn"
                        value="End Subscription"
                    />
                );
        }
    };

    return (
        <Content className="currentSubScriptionContainer">
            <div className="horizontal-container">
                <label className="horizontal-container-element">Subscription Status :</label>
                <span className={getSubscriptionStatusColor(data?.status)}>{data?.status}</span>
            </div>
            <div className="horizontal-container">
                <label className="horizontal-container-element">Period : </label>
                <span className="horizontal-container-element">
                    {data?.period_of_hire} <span>Months</span>
                </span>
            </div>
            {data?.status !== 'pending' && (
                <div className="horizontal-container">
                    <label className="horizontal-container-element">Next Due Date : </label>
                    <span className="horizontal-container-element">{data?.next_payment}</span>
                </div>
            )}
            <div className="horizontal-container">
                <label className="horizontal-container-element">Confirmation Number : </label>
                <span className="horizontal-container-element">#{data?.confirmation_number}</span>
            </div>
            <div className="horizontal-container">
                <label className="horizontal-container-element">Start Date : </label>
                <span className="horizontal-container-element">
                    {moment(data?.start_date, 'DD-MM-YYYY').format('DD MMMM YYYY')}
                </span>
            </div>
            <div className="horizontal-container">
                <label className="horizontal-container-element">End Date : </label>
                <span className="horizontal-container-element">
                    {moment(data?.end_date, 'DD-MM-YYYY').format('DD MMMM YYYY')}
                </span>
            </div>
            {/* Car info section */}
            <section>
                <div className="current-subscription-label-container">
                    <CarOutlined className="current-subscription-icon" />
                    <h4 className="current-subscription-icon">Car Information</h4>
                </div>
                <img className="car-img" src={data?.vehicle?.feature_photo} alt="car" />
                <div className="horizontal-container">
                    <label className="horizontal-container-element">Car Name : </label>
                    <h6 className="horizontal-container-element label-information">
                        {/* {subscription.length > 0 && subscription[0].vehicle.name} */}
                        {`${data?.vehicle?.year} ${data?.vehicle?.name}`}
                    </h6>
                </div>
                <div className="horizontal-container">{renderVehiclePlate(data?.status)}</div>
            </section>
            {/* Car info section end */}
            {/* Subscriber information section */}
            <section>
                <div className="current-subscription-label-container">
                    <UserOutlined className="current-subscription-icon" />
                    <h4 className="current-subscription-icon">Subscriber Information</h4>
                </div>
                <div className="horizontal-container">
                    <label className="horizontal-container-element">Name : </label>
                    <h6 className="horizontal-container-element label-information">
                        {`${data?.subscriber.first_name} ${data?.subscriber.last_name}`}
                    </h6>
                </div>
                <div className="horizontal-container">
                    <label className="horizontal-container-element">Phone : </label>
                    <h6 className="horizontal-container-element label-information">
                        {data?.subscriber?.profile?.contact_number}
                    </h6>
                </div>
                <div className="horizontal-container">
                    <label className="horizontal-container-element">Address : </label>
                    <h6 className="horizontal-container-element label-information">
                        {data?.subscriber?.profile?.address}
                    </h6>
                </div>
            </section>
            {/* Subscriber information section end */}
            {/* Subscriber information section */}
            <section>
                <div className="current-subscription-label-container">
                    <CreditCardOutlined className="current-subscription-icon" />
                    <h4 className="current-subscription-icon">Payment Information</h4>
                </div>
                <div className="horizontal-container">
                    <label className="horizontal-container-element">Card : </label>
                    <h6 className="horizontal-container-element label-information">{data?.payment?.number}</h6>
                </div>
                <div className="horizontal-container">
                    <label className="horizontal-container-element">Expiry Date : </label>
                    <h6 className="horizontal-container-element label-information">{data?.payment?.expiry_date}</h6>
                </div>
            </section>
            {/* Subscriber information section end */}
            {/* Subscriber information section */}
            <section>
                <div className="current-subscription-label-container">
                    <CreditCardOutlined className="current-subscription-icon" />
                    <h4 className="current-subscription-icon">Delivery Information</h4>
                </div>
                <div className="horizontal-container">
                    <label className="horizontal-container-element">Address : </label>
                    <h6 className="horizontal-container-element label-information">
                        {data?.delivery?.address_line_one}
                    </h6>
                </div>
            </section>
            {/* Subscriber information section end */}
            {/* Billing History section */}
            {data?.status === 'pending' ? (
                <section>
                    <Button
                        loading={downloadContractLoading}
                        type="link"
                        icon={<DownloadOutlined />}
                        style={{ marginTop: '40px', position: 'absolute' }}
                        onClick={() => handleDownload(data?.id)}
                    >
                        Download Contract
                    </Button>
                    <input
                        type="button"
                        onClick={() => handleCancelSubscription(data?.id)}
                        className="btnSubscripton danger-btn"
                        value="Cancel Subscription"
                    />
                </section>
            ) : (
                <section>
                    <div className="current-subscription-label-container">
                        <SolutionOutlined className="current-subscription-icon" />
                        <h4 className="current-subscription-icon">Billing History</h4>
                    </div>
                    <Table columns={columns} dataSource={billings} />
                    {
                        // data?.status!== 'rejected' || data?.status!== 'closed' || (
                        //     <input
                        //     type="button"
                        //     onClick={() => handleUpdateSubscriptionUseCallBack('closed')}
                        //     className="btnSubscripton danger-btn"
                        //     value="End Subscription"
                        // />
                        // )
                        renderEndSubscriptionButton(data?.status)
                    }
                </section>
            )}
            <InvoiceDialog
                open={invoiceDialog.visible}
                bill={invoiceDialog.data}
                subscriber={data}
                cards={cards}
                token={token}
                handleClose={handleVisibleInvoiceDialog}
            />
            {/* Subscriber information section end */}
        </Content>
    );
};

export default CurrentSubscription;

const columns = [
    {
        title: 'Invoice Number',
        dataIndex: 'invoice_number',
        key: 'invoice_number',
        render: (text) => <p style={{ fontSize: 10 }}>{text}</p>,
    },
    {
        title: 'Date',
        dataIndex: 'payment_date',
        key: 'payment_date',
        render: (text) => <p style={{ fontSize: 10 }}>{text}</p>,
    },
    {
        title: 'Price(usd)',
        dataIndex: 'included_tax',
        key: 'included_tax',
        render: (text) => <p style={{ fontSize: 10 }}>{text}</p>,
    },
    {
        title: 'Card Type',
        dataIndex: 'card',
        key: 'card',
        render: (card) => <p style={{ fontSize: 10 }}>{card?.brand}</p>,
    },
    {
        title: 'Status',
        key: 'payment_status',
        dataIndex: 'payment_status',
        render: (text) => (
            <span>
                <Tag color={getPaymentStatusColor(text)} style={{ fontSize: 10 }}>
                    {text}
                </Tag>
            </span>
        ),
    },
    {
        title: 'Action',
        key: 'action',
        render: (record) => {
            return (
                <span>
                    <label className="tableAction" onClick={() => record.viewInvoice({ visible: true, bill: record })}>
                        View
                    </label>
                    <label
                        className="tableAction"
                        onClick={() => {
                            downloadInvoice({ token: global_token, record: record });
                        }}
                    >
                        Download
                    </label>
                </span>
            );
        },
    },
];

const getPaymentStatusColor = (status) => {
    switch (status) {
        case 'Unpaid':
            return 'red';
        case 'Paid':
            return 'green';
        default:
            return 'red';
    }
};
